export default __webpack_public_path__ + "static/media/71.aa04f820.jpg";